<script module lang="ts">
	const FORMSPARK_ACTION_URL = 'https://submit-form.com/1pkRW2WP8';
</script>

<script lang="ts">
	import { preventDefault } from 'svelte/legacy';

	import { months } from '$lib/domain/freshness';
	import { locale, t } from '$lib/translations';

	interface Props {
		cutoffDate?: Date | undefined;
		title?: any;
		referer?: string;
	}

	let { cutoffDate = undefined, title = $t('shared.messageCorner'), referer = '' }: Props = $props();

	let submitting = $state(false);

	let name = $state('');
	let email = $state('');
	let message = $state('');

	const showForm = cutoffDate && months(cutoffDate).old() < 6;

	async function onSubmit() {
		try {
			submitting = true;

			await fetch(FORMSPARK_ACTION_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json'
				},
				body: JSON.stringify({
					referer,
					name,
					email,
					message
				})
			});

			name = '';
			email = '';
			message = '';

			alert('Messaggio inviato: grazie per aver scritto!');
		} finally {
			submitting = false;
		}
	}
</script>

{#if showForm}
	<div class="border-b font-sans italic text-xl mb-4 -mx-8 px-8">
		<p class="border-b-4 inline-block">{title}</p>
	</div>
	<p class="text-sm italic">
		{#if $locale === 'it'}
			Il form per i messaggi qui sotto non fa altro che inviare quel che scrivi alla mia casella di posta. Così non devi aprire il programma di email e neanche
			ricordarti il mio indirizzo.
		{/if}
		{#if $locale === 'en'}
			The message form below just sends what you write to my inbox. So you don't have to open the email program or even remember my address.
		{/if}
	</p>
	<form class="mt-4 grid grid-cols-2 gap-4" action={FORMSPARK_ACTION_URL} onsubmit={preventDefault(onSubmit)}>
		<label class="block" for="name">
			<span class="block uppercase font-sans text-sm">{$t('shared.name')}</span>
			<input
				class="mt-0 block w-full px-0.5 border-0 border-b-2 border-medium-gray focus:ring-0 focus:border-black"
				type="text"
				id="name"
				name="name"
				placeholder={$t('shared.whoAreYou')}
				required
				bind:value={name}
			/>
		</label>
		<label class="block" for="email">
			<span class="block uppercase font-sans text-sm">Email</span>
			<input
				class="mt-0 block w-full px-0.5 border-0 border-b-2 border-medium-gray focus:ring-0 focus:border-black"
				type="email"
				id="email"
				name="email"
				placeholder="Email"
				required
				bind:value={email}
			/>
		</label>
		<label class="block col-span-2" for="message">
			<span class="block text-sm font-sans">{@html $t('shared.tellMeEverythingExceptSpam')}</span>
			<textarea
				id="message"
				name="message"
				placeholder=""
				required
				class="mt-0 block w-full px-0.5 border-0 border-b-2 border-medium-gray focus:ring-0 focus:border-black"
				bind:value={message}
			></textarea>
		</label>
		<div>
			<input type="hidden" value={referer} />
			<button type="submit" class="button bg-sage-green text-sapphire rounded-sm px-4" disabled={submitting}>{$t('shared.send')}...</button>
		</div>
	</form>
{/if}
